import { Button as ButtonPorky } from '@PorkyCol/button';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from '@nextui-org/react';
import { Iconic } from '@commons/iconic';
import React, { useMemo, useRef, useState } from 'react';
import { getProductsResumeService } from '@/services';
import { useQuery } from '@tanstack/react-query';
import { useItemList } from '@modules/orders/hooks/useItemsList';
import { ModalDescriptionOrderDetail } from '../../components/modals/descriptionOrderDetail';

type Props = {
  isEdit?: boolean;
  isForm?: boolean;
  defaultValuesItems?: any;
  id?: string;
  searchTerm?: string;
};

export const OrderSimpleButtons = ({ defaultValuesItems, searchTerm = '' }: Props) => {
  
  const { data } = useQuery({
    queryKey: ['products', getProductsResumeService],
    select: (dataTemp: any) => {
      const productsByCategories: any = {};
      const products: any = {};
      /*       console.log("🚀 ~ CreateSimpleOrder ~ dataTemp", dataTemp)
       */
      dataTemp?.data?.forEach((product: any) => {
        if (product?.product?.categories?.length) {
          product.product.categories.forEach((category: any) => {
            if (!category.status) return;
            if (!productsByCategories[category.id]) {
              const categorie = {
                name: category.name,
                products: [
                  {
                    id: product.id,
                    name: product.product.name,
                    price: product.sellLetter,
                    image: product.product.image,
                  },
                ],
              };
              productsByCategories[category.id] = categorie;
            } else {
              productsByCategories[category.id].products.push({
                id: product.id,
                productId : product.product.id,
                name: product.product.name,
                price: product.sellLetter,
                image: product.product.image,
              });
            }
            products[product.id] = {
              id: product.id,
              productId : product.product.id,
              name: product.product.name,
              price: product.sellLetter,
              image: product.product.image,
            };
          });
        } else {
          products[product.id] = {
            id: product.id,
            productId : product.product.id,
            name: product.product.name,
            price: product.sellLetter,
            image: product.product.image,
          };
        }
      });

      return {
        productsByCategories,
        products,
      };
    },
    queryFn: getProductsResumeService,
  });
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  const [idDescriptionProduct, setIdDescriptionProduct] = useState('');
  const [description, setDescription] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  

  const { append, remove, fields, setValue, items } = useItemList({
    isEdit: false,
    defaultValuesItems,
  });
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };
  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };
  const handlePress = (index: any, historyProductId: string) => {
    const product = data?.products[historyProductId];
    const existingProduct = items?.items?.find(
      (p: { customId: string; description: string | any[] }) =>
        p?.customId === historyProductId && !p.description?.length
    );
    const existingProductIndex = items?.items?.findIndex(
      (p: { customId: string; description: string | any[] }) =>
        p?.customId === historyProductId && !p.description?.length
    );
    if (existingProduct) {
      return setValue(
        `items[${existingProductIndex}].quantity`,
        // eslint-disable-next-line no-unsafe-optional-chaining
        items?.items[existingProductIndex]?.quantity + 1 || 1
      );
    }
    return append({
      id: product.productId,
      customId: historyProductId,
      name: product?.name,
      price: product?.price,
      quantity: 1,
    });
  };
  const handleProductSelection = (productId: string) => {
    setIdDescriptionProduct(productId);
    onOpen();
  };
  const pressConfirm = (newProduct: any) => {
    // setSelectedProducts((prevSelectedProducts) => [...prevSelectedProducts, newProduct]);
  };
  const handlePressWithDescription = (index: any, productId: string) => {
    const product = data?.products[productId];
    append({
      id: productId,
      customId: productId,
      name: product?.name,
      price: product?.price,
      quantity: 1,
      description,
    });
    setDescription('');
    setIdDescriptionProduct('');
    onOpenChange();
  };

  // Filtro de productos considerando categoría y búsqueda
  const filteredProducts = useMemo(() => {
    let products: any[] = [];

    // Filtrar por categoría si hay una seleccionada
    if (selectedCategory && data?.productsByCategories[selectedCategory]) {
      products = data.productsByCategories[selectedCategory].products;
    } else {
      // Mostrar todos los productos si no hay categoría seleccionada
      products = Object.values(data?.products || {});
    }

    // Aplicar el filtro de búsqueda
    if (searchTerm) {
      products = products.filter((product: any) =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    return products;
  }, [data?.products, data?.productsByCategories, searchTerm, selectedCategory]);

    // Manejar la selección/des-selección de categorías
    const handleCategorySelection = (categoryId: string) => {
      // Si la categoría seleccionada es la misma, des-seleccionarla
      setSelectedCategory((prevCategory) =>
        prevCategory === categoryId ? null : categoryId
      );
    };

  return (
    <div className="">
      {/* Aquí empieza el carrusel */}
      <div
        className="flex gap-3 items-center rounded-full p-1 overflow-x-auto w-full justify-center mb-4 relative"
        ref={scrollContainerRef}
      >
        <button onClick={scrollLeft} className="bg-gray-300 p-2 rounded-full absolute left-0 hidden md:flex">
          &larr;
        </button>
        
        {data?.productsByCategories &&
          Object.entries(data.productsByCategories).map(([categoryId, category]: any) => (
            <ButtonPorky
            key={categoryId}
            className={`${
              selectedCategory === categoryId ? 'bg-green-900' : 'bg-green-400'
            } text-black font-bold rounded-full px-4 py-2 max-w-fit min-w-fit`}
            onClick={() => handleCategorySelection(categoryId)} // Cambia la categoría seleccionada
          >
            {category.name}
          </ButtonPorky>
          ))}
        <button onClick={scrollRight} className="bg-gray-300 p-2 rounded-full right-0 absolute hidden md:flex">
          &rarr;
        </button>
      </div>

      {/* Aquí empiezan las cards */}
      <div className="gap-2 grid grid-cols-2 sm:grid-cols-3 w-full mx-0 overflow-y-auto max-h-[610px] p-1">
        {filteredProducts.map((product: any, index: number) => (
          <Card shadow="sm" key={index} isPressable>
            <CardBody
              className="overflow-visible p-0 relative"
              onClick={() => handlePress(index, product?.id)}
            >
              {(items?.items?.find((p: { customId: any }) => p?.customId === product.id)
                ?.quantity ?? 0) > 0 && (
                <div className="z-50 absolute right-1 top-1 bg-success-800 font-bold text-white w-8 h-8 justify-center items-center flex text-center rounded-full">
                  {
                    items?.items?.find((p: { customId: any }) => p?.customId === product.id)
                      ?.quantity
                  }
                </div>
              )}
              <Image
                shadow="sm"
                radius="lg"
                width="100%"
                alt={product.name}
                className="w-full object-cover h-[154px]"
                src={product.image}
              />
            </CardBody>
            <CardFooter className="text-small justify-between">
              <b>{product.name}</b>
              <div className="flex flex-row gap-1 justify-center text-center items-center">
                <p className="text-default-500">${product?.price?.toLocaleString()}</p>
                <Button
                  isIconOnly
                  onPress={() => handleProductSelection(product.id)}
                  className="h-5 w-5! min-w-5"
                  color="warning"
                >
                  <Iconic
                    width={18}
                    color="white"
                    icon="material-symbols-light:description-outline"
                  />
                </Button>
              </div>
            </CardFooter>
          </Card>
        ))}
        {/* Modal sin Header, Body o Footer */}
      </div>
    <ModalDescriptionOrderDetail
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      idDescriptionProduct={idDescriptionProduct}
      append={append}
      data={data}
      setIdDescriptionProduct={setIdDescriptionProduct}
    />
    </div>
  );
};
